import React from "react";
import { Button } from "react-bootstrap";

export default function G2ReviewModal({ reviewUrl, onClose }:any) {
    console.log('reviewUrl: ', reviewUrl);
  if (!reviewUrl) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <Button onClick={onClose} style={styles.close}>X</Button>

        <iframe
          src={reviewUrl}
          title="G2 Review"
          width="100%"
          height="600px"
          frameBorder="0"
        />
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed" as React.CSSProperties['position'],
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.6)",
    display: "flex" as React.CSSProperties['display'],
    justifyContent: "center" as React.CSSProperties['justifyContent'],
    alignItems: "center" as React.CSSProperties['alignItems'],
    zIndex: "11111111111111111111111"
  } as React.CSSProperties,
  modal: {
    width: "800px",
    background: "transparent",
    padding: "20px",
    borderRadius: "8px"
  } as React.CSSProperties,
  close: {
    float: "right" as React.CSSProperties['float'],
    background: "red",
    border: "none",
    fontSize:"25px",
    color: "white",
    fontWeight: "600"
  } as React.CSSProperties
};
